export default "__VITE_ASSET__CCpKzNrv__"